import axios from 'axios'
import common from './common'
// import testJson from "../unitest/test.json"
window.isRefreshing = false
let refreshSubscribers = []

// axios.defaults.baseURL = "/api";
let base = common.http=='http://localhost:8080/'?'':common.http;
// const base = axios.defaults.baseURL


function subscribeTokenRefresh(cb) {
    refreshSubscribers.push(cb);
}

function onRrefreshed(token) {
    refreshSubscribers.map(cb => cb(token));
}

function requestToken() {
    return axios({
        method: "post",
        url: `${base}api/v1/Auth/RequestToken`,
        params: {
            "UserName": "adks",
            "Password": "12345678"
        },
        headers: {
            'Content-Type': 'application/json'
        }
    })
}
axios.interceptors.request.use(config => {

    if (config.url.lastIndexOf("api/v1/Auth/RequestToken") != -1) {
        return config
    } else if (config.url.lastIndexOf("api/v1/Auth/GetTrueIp") != -1) {
        return config
    } else if (config.url.lastIndexOf('api/v1/home') != -1) {
        return config
    } else {

        let token = common.req_token;
        if (token) {
            config.headers.Authorization = 'Bearer ' + token
            return config;
        } else {
            if (!window.isRefreshing) {
                window.isRefreshing = true
                requestToken().then(r => {
                   if (r) {
                    console.log(r)
                    common.req_token = r.Data
                    onRrefreshed(r.Data)
                    refreshSubscribers = [];
                    window.isRefreshing = false;
                   }
                })
            }
            let retry = new Promise((resolve) => {
                /*(token) => {...}这个函数就是cb*/
                subscribeTokenRefresh((t) => {
                    config.headers.Authorization = 'Bearer ' + t
                        /*将请求挂起*/
                    resolve(config)
                })
            })
            return retry
        }
    }
}, err => {
    // Message.error({ message: '请求超时!' });
})
axios.interceptors.response.use(data => {
    // const url = data.config.url
    // if (testJson[url]) {
    //     return testJson[url]
    // }
    return data.data;
}, err => {
   
})

// let base = '';
// let base = common.http=='http://localhost:8080/'?'':common.http;
export const postRequest = (url, params) => {

    return axios({
        method: 'post',
        url: `${base}${url}`,
        data: params,
        headers: {
            'Content-Type': 'application/json'
        }
    });
}
export const putRequest = (url, params) => {
    return axios({
        method: 'put',
        url: `${base}${url}`,
        data: params,
        headers: {
            'Content-Type': 'application/json'
        }
    });
}
export const deleteRequest = (url) => {
    return axios({
        method: 'delete',
        url: `${base}${url}`
    });
}
export const getRequest = (url, params) => {
    return axios({
        method: 'get',
        url: `${base}${url}`,
        params: params,
    });
}

export const postRequestVisit = (path, params) => {

    return axios({
      method: 'post',
      url: `https://base2.api.bjadks.com/${path}`,
      data: params,
      headers: {
        'Content-Type': 'application/json'
      }
    });
  }

  export const getRequestVisit = (path, params) => {

    return axios({
      method: 'get',
      url: `https://base2.api.bjadks.com/${path}`,
      data: params,
      headers: {
        'Content-Type': 'application/json'
      }
    });
  }


//获取二维码图片
export const getqr = (url, params) => {
    return axios({
        method: 'get',
        url: `${base}${url}`,
        params: params,
        responseType: 'arraybuffer'
    });
}

export const getUser = (url, params) => {
    console.log(url, params)
    return axios({
        method: 'get',
        url: `https://login.bjadks.com/${url}`,
        params: params,
    });
}


// WEBPACK FOOTER //
// ./src/utils/utils.js